/** @format */
import { Component, ContentChildren, Input, TemplateRef, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'sis-description-list',
    templateUrl: './description-list.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class DescriptionListComponent {
    @Input() fillByColumn = true;
    @Input() columnCount = 2;

    @ContentChildren('listItem', { read: TemplateRef, descendants: true }) childTemplates: TemplateRef<any>[];
}
